import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import MarkdownView from './MarkdownView';

const ListItemDisplay = ({ listItem, consoleItemId, onEdit, onDelete }) => {
  const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const getYouTubeThumbnail = (url) => {
    const videoId = getYouTubeVideoId(url);
    return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : null;
  };

  const isYouTubeLink = (url) => {
    return url && (url.includes('youtube.com') || url.includes('youtu.be'));
  };

  const handleLinkClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-gray-800 p-3 rounded-lg flex items-start gap-3 text-left">
      {/* Display image or link thumbnail */}
      <div className="w-16 h-16 flex-shrink-0">
        {listItem.image ? (
          <img
            src={listItem.image}
            alt={listItem.title}
            className="w-16 h-16 object-cover rounded"
          />
        ) : listItem.link ? (
          <div className="relative">
            {isYouTubeLink(listItem.link) ? (
              <div className="relative">
                <img
                  src={getYouTubeThumbnail(listItem.link)}
                  alt={listItem.title}
                  className="w-16 h-16 object-cover rounded cursor-pointer hover:opacity-80"
                  onClick={() => handleLinkClick(listItem.link)}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <FontAwesomeIcon
                    icon={faYoutube}
                    className="text-red-600 text-xl bg-white bg-opacity-80 rounded-full p-1"
                  />
                </div>
              </div>
            ) : (
              <div
                className="w-16 h-16 bg-gray-600 rounded flex items-center justify-center cursor-pointer hover:bg-gray-500"
                onClick={() => handleLinkClick(listItem.link)}
              >
                <FontAwesomeIcon icon={faExternalLinkAlt} className="text-blue-400 text-xl" />
              </div>
            )}
          </div>
        ) : (
          <div className="w-16 h-16 bg-gray-600 rounded flex items-center justify-center">
            <span className="text-gray-400 text-xs">No media</span>
          </div>
        )}
      </div>

      <div className="flex-1 min-w-0">
        <h5 className="font-semibold">{listItem.title}</h5>
        <MarkdownView source={listItem.description} compact className="mt-1" />
        {listItem.link && (
          <button
            onClick={() => handleLinkClick(listItem.link)}
            className="text-blue-400 hover:text-blue-300 text-sm mt-1 flex items-center"
          >
            <FontAwesomeIcon icon={faExternalLinkAlt} className="mr-1" />
            {isYouTubeLink(listItem.link) ? 'Watch Video' : 'Open Link'}
          </button>
        )}
      </div>

      <div className="flex space-x-1">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded text-xs"
          onClick={() => onEdit(consoleItemId, listItem)}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
        <button
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded text-xs"
          onClick={() => onDelete(consoleItemId, listItem._id)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};

export default ListItemDisplay;